export const ClockIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.375 5.84967V10.3747L12.6583 11.6413M17.4166 10.3747C17.4166 14.2637 14.264 17.4163 10.375 17.4163C6.48597 17.4163 3.33331 14.2637 3.33331 10.3747C3.33331 6.48567 6.48597 3.33301 10.375 3.33301C14.264 3.33301 17.4166 6.48567 17.4166 10.3747Z" stroke="#504C47" stroke-width="1.5" stroke-linecap="square"/>
      </svg>
    );
  }